import { render, staticRenderFns } from "./AddImageDialog.vue?vue&type=template&id=6f956bb4"
import script from "./AddImageDialog.vue?vue&type=script&lang=ts"
export * from "./AddImageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports